<div class="guidelines_table">
  <div class="guidelines_header_section">
    <div style="font-size: 0.98vw; font-weight: 600">Plano Guidelines</div>
    <div class="data_files">
      <button
        #uploadTriggerBtn
        class="menu_trigger"
        [matMenuTriggerFor]="uploadMenu"
      >
        <img src="../../assets/upload.png" alt="upload" />
        Upload Guidelines
        <mat-icon style="color: white" matPrefix>arrow_drop_down</mat-icon>
      </button>
      <mat-menu class="upload" #uploadMenu="matMenu">
        <input
          #fileInput
          type="file"
          (change)="uploadFile($event)"
          accept=".csv"
          style="display: none"
        />
        <button
          [ngClass]="{ selectedOption: selectedUploadFile == file }"
          (click)="openInputForUpload(file)"
          *ngFor="let file of files"
          mat-menu-item
        >
          <span>{{ file }}</span>
        </button>
      </mat-menu>
      <button
        #downloadTriggerBtn
        class="menu_trigger"
        [matMenuTriggerFor]="downloadMenu"
      >
        <img src="../../assets/download.png" alt="download" /> Download
        Guidelines
        <mat-icon style="color: white" matPrefix>arrow_drop_down</mat-icon>
      </button>
      <mat-menu class="download" #downloadMenu="matMenu">
        <button
          [ngClass]="{ selectedOption: selectedDownloadFile == file }"
          (click)="downloadFile(file)"
          *ngFor="let file of files"
          mat-menu-item
        >
          <span>{{ file }}</span>
        </button>
      </mat-menu>
    </div>
  </div>
  <table
    [formGroup]="base_data_dropdown_form_group"
    mat-table
    *ngIf="dataSource.data.length > 0"
    #mytable
    [dataSource]="dataSource"
  >
    <ng-container matColumnDef="channel">
      <th style="padding-left: 10px" mat-header-cell *matHeaderCellDef>
        <mat-form-field *ngIf="channels.length > 0">
          <mat-label> Channel </mat-label>
          <mat-select
            value="dropdown_data_form_group.controls['channel'].value"
            formControlName="channel"
            multiple
          >
            <mat-option (click)="toggleSelection(channel,'channel',0)"  *ngFor="let channel of channels" [value]="channel">{{
              channel
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </th>
      <td mat-cell *matCellDef="let data">{{ data.channel }}</td>
    </ng-container>
    <ng-container matColumnDef="caser">
      <th style="padding-left: 10px" mat-header-cell *matHeaderCellDef>
        <mat-form-field *ngIf="casers.length > 0">
          <mat-label> Caser </mat-label>
          <mat-select
            value="dropdown_data_form_group.controls['caser'].value"
            formControlName="caser"
            multiple
          >
            <mat-option (click)="toggleSelection(caser,'caser',1)"  *ngFor="let caser of casers" [value]="caser">{{
              caser
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </th>
      <td mat-cell *matCellDef="let data">{{ data.caser }}</td>
    </ng-container>
    <!-- <ng-container matColumnDef="order">
      <th style="padding-left: 10px" mat-header-cell *matHeaderCellDef>
       Priority Order
      </th>
      <td mat-cell *matCellDef="let data">{{ data.order }}</td>
    </ng-container> -->
    <ng-container matColumnDef="group">
      <th style="padding-left: 10px" mat-header-cell *matHeaderCellDef>
        <mat-form-field *ngIf="groups.length > 0">
          <mat-label> Group </mat-label>
          <mat-select
            value="dropdown_data_form_group.controls['group'].value"
            formControlName="group"
            multiple
          >
            <mat-option (click)="toggleSelection(group,'group',2)" *ngFor="let group of groups" [value]="group">{{
                group
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </th>
      <td mat-cell *matCellDef="let data">{{ data.group }}</td>
    </ng-container>
    <ng-container matColumnDef="sku_name">
      <th style="padding-left: 10px" mat-header-cell *matHeaderCellDef>
        Condition
      </th>
      <td mat-cell *matCellDef="let data">{{ data.sku_name }}</td>
    </ng-container>
    <!-- <ng-container matColumnDef="facings">
      <th style="padding-left: 10px" mat-header-cell *matHeaderCellDef>
        Facings
      </th>
      <td mat-cell *matCellDef="let data">{{ data.facings }}</td>
    </ng-container> -->
    <ng-container matColumnDef="min_facings">
      <th style="padding-left: 10px" mat-header-cell *matHeaderCellDef>
       Min Facings
      </th>
      <td mat-cell *matCellDef="let data">{{ data.min_facings }}</td>
    </ng-container>
    <ng-container matColumnDef="max_facings">
      <th style="padding-left: 10px" mat-header-cell *matHeaderCellDef>
        Max Facings
      </th>
      <td mat-cell *matCellDef="let data">{{ data.max_facings }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>
  </table>
  <mat-paginator
    *ngIf="adminBaseData && adminBaseData.length > 0"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    hidePageSize="true"
    [length]="filtered_admin_base_data.length"
    (page)="paginationChange($event)"
    class="admin-base-data-paginator"
  >
  </mat-paginator>
  <app-loader
    [is_show_loader]="(loader | async)! || is_show_loader"
  ></app-loader>
</div>
